import { render, staticRenderFns } from "./AppointmentModal.vue?vue&type=template&id=c8f1015a"
import script from "./AppointmentModal.vue?vue&type=script&lang=ts"
export * from "./AppointmentModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports